import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import TrendingIcon from "../assets/images/icons/trend/trending.svg"
import IncreasingIcon from "../assets/images/icons/trend/increasing.svg"
import SteadyIcon from "../assets/images/icons/trend/steady.svg"
import DecreasingIcon from "../assets/images/icons/trend/decreasing.svg"
import FadingIcon from "../assets/images/icons/trend/fading.svg"

export const CurrencyMap = {
  "N/A": "?", // Unkown
  USD: "$", // US Dollar
  EUR: "€", // Euro
  GBP: "£", // British Pound
  JPY: "¥", // Japanese Yen
  AUD: "A$", // Australian Dollar
  CAD: "C$", // Canadian Dollar
  CHF: "CHF", // Swiss Franc
  CNY: "¥", // Chinese Yuan
  SEK: "kr", // Swedish Krona
  NZD: "NZ$", // New Zealand Dollar
  INR: "₹", // Indian Rupee
  RUB: "₽", // Russian Ruble
  ZAR: "R", // South African Rand
  BRL: "R$", // Brazilian Real
  MXN: "Mex$", // Mexican Peso
  TRY: "₺", // Turkish Lira
  TL: "₺", // Turkish Lira
  KRW: "₩", // South Korean Won
  SGD: "S$", // Singapore Dollar
  HKD: "HK$", // Hong Kong Dollar
  NOK: "kr", // Norwegian Krone
  DKK: "kr", // Danish Krone
  PLN: "zł", // Polish Zloty
  THB: "฿", // Thai Baht
  MYR: "RM", // Malaysian Ringgit
  IDR: "Rp", // Indonesian Rupiah
  SAR: "﷼", // Saudi Riyal
  AED: "د.إ", // UAE Dirham
  ARS: "$", // Argentine Peso
  EGP: "£", // Egyptian Pound
  PHP: "₱", // Philippine Peso
  VND: "₫" // Vietnamese Dong
}

export enum ReportUploadColumnTypes {
  PERIOD = "period",
  PLATFORM = "platform",
  TRANSACTION_DATE = "transaction_date",
  SONG_TITLE = "song_title",
  ISRC = "isrc",
  TERRITORY = "territory",
  QUANTITY = "quantity",
  CURRENCY = "currency",
  //SEGMENT = "segment", // moved into ExtendedReportUploadColumnTypes
  //SEGMENT_DESCRIPTION = "segment_description", //deprecated
  GROSS_PROGRESS = "gross_progress",
  NET_PROGRESS = "net_progress",
  SPLIT_RATE = "split_rate",
  UPC = "upc"
}

// This fields will not be added to main RoyaltyReport, it will be added to extended one.
//  In extended one, all fields will exists including the ReportUploadColumnTypes fields.
export enum ExtendedReportUploadColumnTypes {
  COMMISSION_ARTIST = "commission_artist",
  COMMISSION_DISTRIBUTOR = "commission_distributor",
  NET_UNIT_PRICE = "net_unit_price",
  GROSS_UNIT_PRICE = "gross_unit_price",
  SALES_TYPE = "sales_type",
  SEGMENT = "segment"
}

export enum TrendChoices {
  FADING = -2,
  DECREASING = -1,
  STEADY = 0,
  INCREASING = 1,
  TRENDING = 2
}

export const TrendOptions: KSelectOption[] = [
  { value: TrendChoices.TRENDING, label: "Trending", icon: TrendingIcon },
  { value: TrendChoices.INCREASING, label: "Increasing", icon: IncreasingIcon },
  { value: TrendChoices.STEADY, label: "Steady", icon: SteadyIcon },
  { value: TrendChoices.DECREASING, label: "Decreasing", icon: DecreasingIcon },
  { value: TrendChoices.FADING, label: "Fading", icon: FadingIcon }
]

export const CountryOptions: KSelectOption[] = [
  { value: 1, label: "US", value2: "US" },
  { value: 2, label: "TR", value2: "TR" },
  { value: 3, label: "GB", value2: "GB" },
  { value: 4, label: "DE", value2: "DE" },
  { value: 5, label: "FR", value2: "FR" },
  { value: 6, label: "IT", value2: "IT" },
  { value: 7, label: "ES", value2: "ES" },
  { value: 8, label: "NL", value2: "NL" },
  { value: 9, label: "BE", value2: "BE" },
  { value: 10, label: "AT", value2: "AT" },
  { value: 11, label: "CH", value2: "CH" },
  { value: 12, label: "SE", value2: "SE" },
  { value: 13, label: "NO", value2: "NO" },
  { value: 14, label: "DK", value2: "DK" },
  { value: 15, label: "FI", value2: "FI" },
  { value: 16, label: "PL", value2: "PL" },
  { value: 17, label: "PT", value2: "PT" },
  { value: 18, label: "GR", value2: "GR" },
  { value: 19, label: "CZ", value2: "CZ" },
  { value: 20, label: "RO", value2: "RO" },
  { value: 21, label: "HU", value2: "HU" },
  { value: 22, label: "IE", value2: "IE" },
  { value: 23, label: "RU", value2: "RU" },
  { value: 24, label: "UA", value2: "UA" },
  { value: 25, label: "CA", value2: "CA" },
  { value: 26, label: "MX", value2: "MX" },
  { value: 27, label: "BR", value2: "BR" },
  { value: 28, label: "AR", value2: "AR" },
  { value: 29, label: "CL", value2: "CL" },
  { value: 30, label: "CO", value2: "CO" },
  { value: 31, label: "PE", value2: "PE" },
  { value: 32, label: "AU", value2: "AU" },
  { value: 33, label: "NZ", value2: "NZ" },
  { value: 34, label: "JP", value2: "JP" },
  { value: 35, label: "KR", value2: "KR" },
  { value: 36, label: "CN", value2: "CN" },
  { value: 37, label: "IN", value2: "IN" },
  { value: 38, label: "ID", value2: "ID" },
  { value: 39, label: "TH", value2: "TH" },
  { value: 40, label: "VN", value2: "VN" },
  { value: 41, label: "MY", value2: "MY" },
  { value: 42, label: "SG", value2: "SG" },
  { value: 43, label: "PH", value2: "PH" },
  { value: 44, label: "ZA", value2: "ZA" },
  { value: 45, label: "EG", value2: "EG" },
  { value: 46, label: "NG", value2: "NG" },
  { value: 47, label: "KE", value2: "KE" },
  { value: 48, label: "IL", value2: "IL" },
  { value: 49, label: "AE", value2: "AE" },
  { value: 50, label: "SA", value2: "SA" },
  { value: 51, label: "PK", value2: "PK" },
  { value: 52, label: "BD", value2: "BD" },
  { value: 53, label: "TW", value2: "TW" },
  { value: 54, label: "HK", value2: "HK" },
  { value: 55, label: "BG", value2: "BG" },
  { value: 56, label: "HR", value2: "HR" },
  { value: 57, label: "RS", value2: "RS" },
  { value: 58, label: "SK", value2: "SK" },
  { value: 59, label: "SI", value2: "SI" },
  { value: 60, label: "LT", value2: "LT" },
  { value: 61, label: "LV", value2: "LV" },
  { value: 62, label: "EE", value2: "EE" }
]

export const clickupOpitons = [
  { label: "All", value: 0, value2: "all" },
  { label: "Clickup Task Not Exist", value: 1, value2: "clickup_task_not_exist" },
  { label: "Clickup Task Created", value: 2, value2: "clickup_task_created" }
]

export const TAG_OPTIONS = [
  { label: "WL_artist", value: 1 },
  { label: "WL_DK", value: 2 },
  { label: "WL_POTENTIAL", value: 3 }
]

export const AFFILIATE_MESSAGES = [
  "Hey [Name] \nI run Kahuna, an invite-only platform for high-potential indie artists. We offer funding, growth strategy, and full release support, all in one place. \nWe’re building a tight affiliate network of people who recognize great artists before the world catches on. If you intro us to folks like [Artist 1, Artist 2…] and we end up working together, we’ll make sure you’re properly compensated. \nWould love to jump on a quick call to show you what we’re building. It’s something that really changes the game.",
  "Hey [Name] \nWanted to reach out. I co-founded Kahuna, a hands-on, invite-only platform for artists with breakout potential. We’re working closely with a small group, offering upfront advances, sharp release plans, and serious support. \nWe’re also putting together a private circle of people we trust to spot talent early. Thought of you. If you connect us with artists like [Artist 1, Artist 2…] and we move forward with them, we’ll always make sure it’s worth your while. \nUp for a quick chat? Would love to tell you more.",
  "Hey [Name] \nI’m one of the founders of Kahuna, an invite-only platform that works closely with artists we truly believe in. We support everything around a release—funding, strategy, execution—but always in a way that puts the artist in control. \nWe’re building a trusted network of people who really get artists and know how to spot talent. If you connect us with folks like [Artist 1, Artist 2…] and it turns into something, we’ll make sure you’re looked after too. \nWould be great to hop on a quick call and show you what we’re building.",
  "Hope this isn’t too random. I co-run Kahuna, a high-touch, invite-only platform that helps artists we believe in grow the right way. We back them with funding, release plans, and the kind of support that doesn’t get in their way. \nWe’re building a small crew of people who care about artists and have real taste. If you intro us to folks like [Artist 1, Artist 2…] and it leads to something, we’ll make sure you share in the upside. \nOpen to a quick call? Would love to walk you through what we’re doing.",
  "Copy all messages"
]

export const dmEnMessage1 = `Hey <artist_name>, I really liked what you did with <track_title>.

I’m one of the co-founders of Kahuna, an invite-only platform for artists with serious momentum. Unlike most distributors, we combine financing, release strategy, and tech to actually help artists grow.

We’re based in London, LA and Istanbul, backed by top VCs, and co-founded with Brian Felsen, former President of CD Baby.

Here’s what we offer:
• Advances based on your catalog and audience data
• Hands-on release strategy, DSP growth, and paid marketing support
• Simple one-click catalog transfer from your current distributor
• Custom-built tools to grow your fanbase and revenue

We also launched a private referral program where you can earn by introducing other artists.

If this sounds interesting, I’d love to send more details or set up a quick call.
`

export const dmEnMessage2 = `Hey <artist_name>, just wanted to follow up in case you missed my message.

Kahuna was built to help artists like you keep more of what you earn. Our payout rates are higher than what most distributors offer, and we provide advances with no hidden fees and no rights taken.

Everything is built around helping you grow faster, earn more, and stay in control. We only work with artists we truly believe in, and I think you’d get a lot out of this.

Happy to show you what it could look like.
`

export const dmEnMessage3 = `Hey <artist_name>, wanted to quickly share what some artists are seeing with Kahuna.

One artist with no playlist history landed on four editorials with their first release. Another increased royalties by 40 percent after we helped optimize their catalog. And several have taken upfront advances with no fees and kept full ownership.

We make it easy to grow your revenue and reach without losing control. Let me know if you’d like to see how this could work for you.
`

export const dmScoutEnMessage1 = `Hey <artist_name>, loved what you did with <track_title>.

I’m <user_name> from Kahuna. We’re invite-only for artists with real traction.

We help older tracks and new releases get more streams and keep more payout with smart repitching, focused ads, and catalog cleanup that stops revenue leaks. We also provide advances tied to actual performance, and your rights stay yours.

Want me to show you what that could mean for your music?
`

export const dmScoutEnMessage2 = `Hey <artist_name>, quick follow up in case you missed my note.

We help artists keep more of what they earn and grow faster with smart repitching, focused ads, and cleanup that stops revenue leaks. We are not just an upload tool. We work hands on and fund against real performance while you keep your rights.

We only work with artists we truly believe in, and I think you’d get a lot out of this.

Happy to show you what it could look like.
`

export const dmScoutEnMessage3 = `Hey <artist_name>, quick wins we’re seeing:

• 4 editorials on a first release
• ~40% royalty lift after catalog optimization
• Advances with no fees; you keep full ownership
• Biggest jump: from 150K → 1M Spotify monthly listeners in a week after funding a release plan

We’re onboarding a small cohort now. 

Want a one-page plan for your catalog?
`

export const dmScoutEnMessage4 = `Hi <artist_name>,

Big fan here. <track_title> has been on repeat for me.

I noticed some of your back catalog is going out through <distributor_name>. That setup works fine for hobbyists, but it sells serious artists short. <distributor_name> uploads. It does not bring actionable insights, promo, or capital to amplify what is already working.

With Kahuna, migration is one click on our side with no loss of streams or rankings. You do nothing beyond sharing audio files. We deliver first, confirm matches on the platforms, then trigger takedowns. No hassle, no risk.

We do not just keep your songs online, we reactivate them. You keep 100 percent of your rights while we bring playlist pitching, promo support, and optional funding so your streams grow instead of stalling.

If you prefer, we can start small with an advance for a single track like <track_title>, or we can do your whole back catalog. Your call.

What is the best way to share more details with you, WhatsApp or email?
`

export const dmScoutEnMessage5 = `From what we can see, you still own some of your back catalog. That means we can start together right now without touching the new stuff.

Here is a simple plan:

•⁠  ⁠We put an advance on either one song "<track_title>", a few songs, or your full back catalog. Your call.

•⁠  ⁠Migration is one click on our side. We keep your ISRCs and UPCs, deliver first, confirm matches, then handle takedowns. No lost streams or rankings.

•⁠  ⁠While the advance recoups, we work the catalog with playlist pitching, optimization, and missed-revenue capture so you get back to monthly royalties faster.

You get cash now, keep 100% of your rights, and set the catalog up to grow instead of sitting on autopilot.

Want us to run numbers for one key track or for the whole catalog you own. We can share more with you if you let us know the best way to communicate (Whatsapp or email?)
`

export const dmScoutEnMessage6 = `Hi <artist_name>,

I know you said you’re not looking for distribution or funding right now, but sticking with <distributor_name> is selling yourself short. That platform is fine for hobbyists who just want their music online. You are past that.

With Kahuna, migration is one click on our side with no loss of streams or rankings. You do nothing beyond sharing audio files. We deliver first, confirm matches on the platforms, then trigger takedowns. No hassle, no risk.

We do not just keep your songs online, we reactivate them. You keep 100% of your rights while we bring playlist pitching, promo support, and optional funding so your streams grow instead of stalling.

What is the best way to share more info, WhatsApp or email?
`

export const dmScoutEnMessage7 = `Hi <artist_name>,
 
Thanks for the update. If you do not own any of your back catalog, we can still work together on new releases with Kahuna Core.
 
What you get:
- 85/15 split in your favor on gross royalties (you receive 85% of all gross royalties)
- Premium distribution with playlist pitching and rollout support
- Clean analytics, daily trends, YouTube/UGC monetization, smartlinks, and fast support
 
If you ever regain or release anything you own outright later, we can migrate those titles in one click with no loss of streams or rankings. What is the best way to share more info, WhatsApp or email?
`

export const dmTrMessage1 = `<artist_name> selamlar 😊
<track_title> şu ana kadar dinlediğimiz en sevdiğimiz işlerinden biri 🎧

Biz Londra, Los Angeles ve İstanbul merkezli bir ekibiz.

Kahuna olarak, sanatçılara katalog bazlı avans, tek tıkla katalog transferi, yayın stratejisi, pazarlama desteği ve gelirlerini artırmaya yönelik teknoloji çözümleri sunuyoruz.

Ayrıca, tanıdığın başka sanatçıları davet ederek gelir elde edebileceğin özel bir referans programımız da var 💸

İlgini çekerse sistemi kısaca anlatmak isteriz. 15 dakikalık bir görüşme ayarlayalım mı? 
`

export const dmTrMessage2 = `<artist_name> selamlar, yine ben! 👋

Kahuna’yı bağımsız sanatçıların daha çok kazanabilmesi ve kontrolü elinde tutabilmesi için kurduk.

Kataloğuna göre avans veriyoruz ve sanatçı odaklı dağıtım altyapımızla gelirlerini artıracak şeffaf bir sistem sunuyoruz.

Zaten sadece inandığımız sanatçılarla çalışıyoruz. Senin uygun olduğunu düşünmesek burada olmazdık 🙂
`

export const dmTrMessage3 = `<artist_name> bu son, söz 😄

Kahuna ile çalışan bazı sanatçılar neler başardı, kısaca paylaşayım dedim:

Hiç editorial geçmişi olmayan bir sanatçı, ilk şarkısıyla 4 listeye girdi 🚀

Bir başkası, bizimle çalıştıktan sonra telif gelirini yüzde 40 artırdı 📈

Pek çok sanatçı da bizden avans alarak yeni yayınları için kaynak oluşturdu 💸

Tek istediğimiz 15 dakikan ⏱ Ne sunduğumuzu beğenmezsen bir daha rahatsız etmeyiz, söz 🙂
`

export const emailEnSubject1 = `Platform invite for serious independent artists`
export const emailEnMessage1 = `Hey <artist_name>,

Loved what you did with <track_title>.

I’m one of the co-founders of Kahuna, an invite-only platform for artists with real momentum. Unlike most distributors, we combine financing, release strategy, and tech to actually help you grow.

We’re based in London, LA, and Istanbul, backed by top VCs, and co-founded with Brian Felsen, former President of CD Baby.

Here’s what we offer:

-Upfront advances based on your catalog and audience data
-Hands-on release strategy, DSP growth, and paid marketing support
-Simple one-click catalog transfer from your current distributor
-Custom-built tools to grow your fanbase and revenue

We also launched a private A&R / Scout program: intro other artists and earn a share if they join.

If this sounds interesting, happy to send more details or set up a quick call.

Best,
<user>
`

export const emailEnSubject2 = `Looking for an advance to fuel your next release?`
export const emailEnMessage2 = `Hey <artist_name>,

Just checking in.

Kahuna was built to make sure independent artists don’t leave money on the table. Our payout rates are higher than what most distributors offer, and we’re careful to make sure you keep more of what you earn.

If you need an advance, we can provide it with no extra fees. And if you refer other artists, you get paid for that too.

It’s designed to be fair, flexible, and built for growth.

Let me know if you’d like to see how it could work for you.

Best,
<user>
`

export const emailEnSubject3 = `This is working for artists like you`
export const emailEnMessage3 = `Hey <artist_name>,

Just wanted to share what artists are experiencing after joining Kahuna:

One artist with no playlist history landed on four playlists with their first release

Another saw their monthly revenue increase by 40 percent after we optimized their catalog

Several have taken upfront advances with no fees and kept full control of their rights

We’ve made it easy to earn more per stream, grow faster, and keep ownership. Everything is designed to support serious artists without wasting time or money.

Let me know if you’d like to see what this could look like for you.

Best,
<user>
`

export const emailScoutEnMessage1 = `Hi <artist_name>,

Loved what you did with <track_title>, it is on repeat here. 

I’m <user_name> from Kahuna. We work with independent artists who already have traction, helping grow revenue and reach while you keep full control of your rights.

Here’s how we could help on your next steps:
• Playlist pitching and rollout support to turn momentum into real growth
• Targeted ads and analytics to find new listeners and build repeat plays
• Advances based on real catalog performance, with no rights taken
• A single dashboard showing streams, royalties, playlists, and daily trends
• One-click catalog transfer from your current distributor with no loss of streams or rankings

If this sounds useful, I’d be happy to run numbers on one of your tracks and show you what it could look like.

Best,
<user_name>
kahuna.io`

export const emailScoutEnMessage2 = `Just following up.

Kahuna is co-founded with BrianFelsen, former President of CD Baby, and we’re backed by top VCs in London, LA, NY, and Istanbul. Our focus is helping independent artists expand their reach and revenue while keeping ownership intact.

That means:
• Higher payout rates than most distributors
• Growth support through editorial pitching and marketing, not just upload-and-forget
• Advances with no hidden fees, sized from your actual performance

If you can share the last 12 months of royalty reports for the tracks you own or control, I can send back a clear model showing what your catalog could earn with us.

If it helps, you can start with one song only. We will move that track first, provide an interest-free advance on that song, and handle distribution, pitching, and reporting. If you are happy with the team and the platform, you can then move the rest of your back catalog to us.

Best,
<user_name>
kahuna.io
`

export const emailScoutEnMessage3 = `A couple of quick examples from artists who joined us recently:
• An artist with no playlist history landed on four editorials with their first release
• Another grew royalties by 40% after we optimized their back catalog
• Several took upfront advances with no fees and kept full ownership

We can do the same kind of modeling for you. If you send over the last 12 months of royalty statements for the tracks you own or control, we’ll prepare a tailored proposal and show you what an advance and rollout plan could look like.

Would you like me to set that up?

Best,
<user_name>
kahuna.io
`

export const emailScoutEnMessage4 = `Hi <artist_name>,

Big fan here. <track_title> has been on repeat for me.

I noticed some of your back catalog is going out through <distributor_name>. That setup works fine for hobbyists, but it sells serious artists short. <distributor_name> uploads. It does not bring promo, growth, or capital to amplify what is already working.

With Kahuna, migration is one click on our side with no loss of streams or rankings. You do nothing beyond sharing audio files. We deliver first, confirm matches on the platforms, then trigger takedowns. No hassle, no risk.

We do not just keep your songs online, we reactivate them. You keep 100 percent of your rights while we bring playlist pitching, promo support, and optional funding so your streams grow instead of stalling.

If you prefer, we can start small with an advance for a single track like <track_title>, a few other songs, or we can do your whole back catalog. Your call.

Best,
<user_name>
kahuna.io
`

export const emailScoutEnMessage5 = `From what we can see, you still own some of your back catalog. That means we can start together right now without touching the new stuff.

Here is a simple plan:

•⁠  ⁠We put an advance on either one song "<track_title>", a few other songs, or your full back catalog. Your call.

•⁠  ⁠Migration is one click on our side. We keep your ISRCs and UPCs, deliver first, confirm matches, then handle takedowns. No lost streams or rankings.

•⁠  ⁠While the advance recoups, we work the catalog with playlist pitching, optimization, and missed-revenue capture so you get back to monthly royalties faster.

You get cash now, keep your rights, and set the catalog up to grow instead of sitting on autopilot.

Want us to run numbers for one key track or for the whole catalog you own. 

Best,
<user_name>
kahuna.io
`

export const emailScoutEnMessage6 = `Hi <artist_name>,
 
I know you said you’re not looking for distribution or funding right now, but sticking with <distributor_name> is selling yourself short. That platform is fine for hobbyists who just want their music online. You are past that.
 
With Kahuna, migration is one click on our side with no loss of streams or rankings. You do nothing beyond sharing audio files. We deliver first, confirm matches on the platforms, then trigger takedowns. No hassle, no risk.
 
We do not just keep your songs online, we reactivate them. You keep 100 percent of your rights while we bring playlist pitching, promo support, and optional funding so your streams grow instead of stalling.

Best,
<user_name>
kahuna.io
`

export const emailScoutEnMessage7 = `
Hi <artist_name>,

Thanks for the update. If you do not own any of your back catalog, we can still work together on new releases with Kahuna Core.

What you get:
- 85/15 split in your favor on gross royalties (you receive 85% of all gross royalties)
- Premium distribution with playlist pitching and rollout support
- Clean analytics, daily trends, YouTube/UGC monetization, smartlinks, and fast support

If you ever regain or release anything you own outright later, we can migrate those titles in one click with no loss of streams or rankings.

Want to start with your next single? 

Best,
<user_name>
kahuna.io
`
export const emailScoutEnMessage8 = `
Hi <artist_name>,
 
Arda here, cofounder at Kahuna and big fan of <track_title>. You’ve got some really strong tracks and clear momentum. I see some of your songs are going out through <distributor_name>. If you own or control some of those masters, there’s room to grow royalties and reach without adding friction.

Here’s where we can help:

• Tighten rollout and visibility with editorial repitching, seasonal pushes, and targeted ads so momentum is not missed
• Fix backend issues through metadata cleanup, lyric delivery, YouTube monetization, and stronger link hygiene
• Fill coordination gaps by unifying distribution with one-click catalog migration for eligible tracks, with no loss of streams or rankings
• Turn brand assets into traction by packaging artwork and visuals to drive UGC, unlock editorial, and extend campaigns
• Provide clear royalty reporting. Kahuna only earns when your royalties grow

Funding is also available:
• Non-restrictive advances against the portion you own. You keep 100 percent of your rights
• Option to put part of that budget toward new releases and paid growth
 
Attached: your Kahuna invitation, a comparison against basic uploaders, and a few artist testimonials.

As a next step, we’d love to model what this could look like for your catalog. Could you please send us just the last 12 months of royalty reports for the tracks you own? That way we can prepare a tailored rollout and an advance option.
 
Best,
<user_name>
kahuna.io
`
export const emailScoutEnMessage9 = `
Hi <artist_name>,
 
I’m <user_name> from Kahuna, an invite-only platform for independent artists who are already building real momentum. We’re based in London, LA, and Istanbul, and co-founded with Brian Felsen, former President of CD Baby.
 
I understand you’re currently distributing with <distributor_name>, which is fine for getting music online quickly, but it’s designed as a self-serve tool. For artists like you who are already breaking through, it doesn’t provide the growth support, data-driven marketing, and release strategy that can help take things to the next level.
 
Here’s how we could help on your next steps:
• One-click catalog transfer with no loss of streams or rankings
• Playlist pitching and rollout support to push your tracks further
• Ads and analytics that find new listeners and keep them coming back
• Advances sized from actual performance, plus reactivation of older tracks
 
Attached: your Kahuna invitation, artist testimonials, and a comparison against basic uploaders.

As a next step, can you please send us the last 12 months of royalty reports for the releases you own or control? That way, we can run numbers specific to your catalog and prepare a tailored proposal, including an advance option.
`

export const emailTrSubject1 = `<track_title> favorilerimizden. Seni Kahuna’ya bekliyoruz!`
export const emailTrMessage1 = `<artist_name> selamlar,
 <track_title> parçasına bayılıyoruz!

Ben Kahuna ekibinden  <user>. Kahuna, potansiyeli yüksek sanatçılarla çalışan bir platform. Çoğu dağıtımcının aksine, finansman, yayın stratejisi ve teknolojiyi bir araya getirerek sanatçıların büyümesini destekliyoruz. 

Londra, Los Angeles ve İstanbul'da ekiplerimiz var.

Kahuna olarak sunduklarımızdan bazıları:
 • Mevcut kataloğun üzerinden avans ödemesi
 • Yayın stratejisi, DSP büyümesi ve reklam destekli pazarlama
 • Mevcut dağıtımcından tek tıkla katalog transferi
 • Gelirini ve kitleni büyütmeye yönelik teknoloji tabanlı çözümler

Ayrıca özel bir referans programı başlattık. Tanıdığın başka sanatçıları yönlendirirsen ve birlikte çalışmaya başlarsak, gelir paylaşımıyla seni de ödüllendiriyoruz.

İlgini çekerse detayları paylaşmak ya da kısa bir görüşme yapmak isteriz.

Sevgiler,
<user>
`

export const emailTrSubject2 = `Gözünden kaçmış olma ihtimaline karşı`
export const emailTrMessage2 = `<artist_name> selamlar,
 Gözünden kaçmış olma ihtimaline karşı bir hatırlatma geçmek istedik.

Kahuna, bağımsız sanatçıların kazancını maksimize etmek üzere kuruldu. Eğer avansa ihtiyacın varsa doğru yerdesin. Ayrıca yönlendirdiğin diğer sanatçılar için de gelir kazanabilirsin.

Sistem adil, şeffaf ve tamamen büyümeye odaklı.

Tek isteğimiz 15 dakikan. Sana kendimizi ve sistemimizi tanıtmak isteriz.

Sevgiler,
<user>
`

export const emailTrSubject3 = `Avans aldı, listeye girdi, gelirini artırdı: Hepsi mümkün`
export const emailTrMessage3 = `<artist_name> selamlar,
 Kahuna’ya katılan sanatçılara sağladığımız bazı somut faydaları paylaşmak istedik:

• Playlist geçmişi olmayan bir sanatçı, ilk yayınıyla dört farklı editorial listeye girdi
• Bir diğeri, kataloğu optimize ettikten sonra aylık gelirini yüzde 40 artırdı
• Birçok sanatçı ön ödeme aldı, hiçbir hak kaybı yaşamadan yayınlarına devam etti

Her şeyi sanatçının daha fazla kazanması, daha hızlı büyümesi ve sahipliğini koruması için tasarladık.

İstersen senin için nasıl çalışabileceğimizi de göstermek isteriz.

Sevgiler,
<user>
`

export const TaskTypes = {
  ARTIST: "artist",
  AFFILIATE: "affiliate"
}

export const TaskTypeOptions: KSelectOption[] = [
  { value: 1, label: "Artist", value2: TaskTypes.ARTIST },
  { value: 2, label: "Affiliate", value2: TaskTypes.AFFILIATE }
]

export const InboxTypes = {
  ARTIST: "artist",
  AFFILIATE: "affiliate",
  TASK: "task"
}

export const TaskStatusGroups = {
  NOT_STARTED: "Not Started",
  ACTIVE: "Active",
  DONE: "Done",
  CLOSED: "Closed"
}

export const PipelineActionGroups = {
  SCOUTING_AND_DATA_COLLECTION: "Scouting & Data Collection",
  AGREEMENT_AND_SETUP: "Agreement & Setup",
  ONBOARDING_AND_LAUNCH: "Onboarding & Launch",
  OUTREACH_PREPARATION: "Outreach Preparation",
  OUTREACH_AND_CONTACT: "Outreach & Contact",
  DEAL_STRUCTURING: "Deal Structuring"
}

// Offers v2 — gates the new variation-based "Confirm Deal" modal. Flip to true
// to swap the legacy ConfirmDealModal for OffersV2Modal at the same trigger.
export const OFFERS_V2_ENABLED = true

export const DealOfferStatus = {
  DRAFT: "draft",
  OFFER_SENT: "offer_sent",
  ARTIST_REVISION: "artist_revision",
  KAHUNA_REVISION: "kahuna_revision",
  KAHUNA_OFFER: "kahuna_offer",
  APPROVED: "approved",
  REJECTED: "rejected",
  EXPIRED: "expired",
  SIGNED: "signed"
}

export const DealOfferOptions: KSelectOption[] = [
  { value: 1, label: "Draft", value2: DealOfferStatus.DRAFT },
  { value: 2, label: "Offer Sent", value2: DealOfferStatus.OFFER_SENT },
  { value: 3, label: "Artist Revision", value2: DealOfferStatus.ARTIST_REVISION },
  { value: 4, label: "Kahuna Revision", value2: DealOfferStatus.KAHUNA_REVISION },
  { value: 6, label: "Approved", value2: DealOfferStatus.APPROVED },
  { value: 7, label: "Rejected", value2: DealOfferStatus.REJECTED },
  { value: 8, label: "Expired", value2: DealOfferStatus.EXPIRED },
  { value: 9, label: "Signed", value2: DealOfferStatus.SIGNED }
]

export const MessageContentTypeOptions = {
  DM: "DM",
  EMAIL: "Email",
  FAQ: "FAQ",
  AFFILIATE_DM: "Affiliate DM",
  PIPELINE_DM: "Pipeline DM",
  PIPELINE_EMAIL: "Pipeline Email"
}

export const MessageContentOptions = [
  { type: MessageContentTypeOptions.DM, lang: "En" },
  { type: MessageContentTypeOptions.DM, lang: "Tr" },
  { type: MessageContentTypeOptions.EMAIL, lang: "En" },
  { type: MessageContentTypeOptions.EMAIL, lang: "Tr" },
  { type: MessageContentTypeOptions.FAQ, lang: "En" },
  { type: MessageContentTypeOptions.AFFILIATE_DM, lang: "En" },
  { type: MessageContentTypeOptions.AFFILIATE_DM, lang: "Tr" },
  { type: MessageContentTypeOptions.PIPELINE_DM, lang: "En" },
  { type: MessageContentTypeOptions.PIPELINE_DM, lang: "Tr" },
  { type: MessageContentTypeOptions.PIPELINE_EMAIL, lang: "En" },
  { type: MessageContentTypeOptions.PIPELINE_EMAIL, lang: "Tr" }
]
export const LICENSE_KEYWORDS: string[] = [
  "RUN",
  "Duetti",
  "under exclusive license",
  "under licence" // UK spelling
]

export const SHORT_LTM_ERROR_RATE = 0.01

export const USER_LOGS_FILTER_TYPES =
  "artist_comment,sent_email,sent_instagram_dm,meeting_held,contact_affiliate,task_comment,scout_comment,sent_whatsapp_message,update_artist_email,add_artist_email,delete_artist_email,set_default_artist_email,outreach_success_instagram_dm,outreach_fail_instagram_dm,outreach_flag_instagram_dm,outreach_success_email,outreach_fail_email,outreach_flag_email,outreach_success_whatsapp,outreach_fail_whatsapp,outreach_flag_whatsapp,pipeline_interested,pipeline_not_interested,instagram_update,phone_update,ig_data_fetch,artist_verified"

// User Log Type Labels - Maps log type to display label
export const USER_LOG_TYPE_LABELS: { [key: string]: string } = {
  artist_comment: "Comment",
  sent_email: "Email Sent",
  sent_instagram_dm: "Instagram DM Sent",
  sent_whatsapp_message: "WhatsApp Sent",
  sent_scout_outreach: "Scout Outreach Sent",
  meeting_held: "Meeting Held",
  contact_affiliate: "Contact Affiliate",
  task_comment: "Task Comment",
  scout_comment: "Scout Comment",
  update_artist_email: "Email Updated",
  add_artist_email: "Email Added",
  delete_artist_email: "Email Deleted",
  set_default_artist_email: "Default Email Set",
  outreach_success_instagram_dm: "Instagram Success",
  outreach_fail_instagram_dm: "Instagram Failed",
  outreach_flag_instagram_dm: "Instagram Flagged",
  outreach_success_email: "Email Success",
  outreach_fail_email: "Email Failed",
  outreach_flag_email: "Email Flagged",
  outreach_success_whatsapp: "WhatsApp Success",
  outreach_fail_whatsapp: "WhatsApp Failed",
  outreach_flag_whatsapp: "WhatsApp Flagged",
  outreach_success_scout: "Scout Outreach Success",
  outreach_fail_scout: "Scout Outreach Failed",
  outreach_flag_scout: "Scout Outreach Flagged",
  pipeline_interested: "Interested",
  pipeline_not_interested: "Not Interested",
  instagram_update: "Instagram Updated",
  phone_update: "Phone Updated",
  ig_data_fetch: "IG Data Fetched",
  artist_verified: "Artist Verified",
  pipeline_artist_comment: "Pipeline Comment"
}

// Badge style types
interface BadgeStyle {
  backgroundColor: string
  color: string
}

// User Log Type Badge Styles - Maps log type to badge colors
export const USER_LOG_TYPE_BADGE_STYLES: { [key: string]: BadgeStyle } = {
  // Sent messages - blue
  sent_email: { backgroundColor: "#cfe2ff", color: "#084298" },
  sent_instagram_dm: { backgroundColor: "#cfe2ff", color: "#084298" },
  sent_whatsapp_message: { backgroundColor: "#cfe2ff", color: "#084298" },
  sent_scout_outreach: { backgroundColor: "#cfe2ff", color: "#084298" },

  // Success outreach - green
  outreach_success_instagram_dm: { backgroundColor: "#d4edda", color: "#155724" },
  outreach_success_email: { backgroundColor: "#d4edda", color: "#155724" },
  outreach_success_whatsapp: { backgroundColor: "#d4edda", color: "#155724" },
  outreach_success_scout: { backgroundColor: "#d4edda", color: "#155724" },
  pipeline_interested: { backgroundColor: "#d4edda", color: "#155724" },

  // Failed outreach / not interested / deleted - red
  outreach_fail_instagram_dm: { backgroundColor: "#f8d7da", color: "#721c24" },
  outreach_fail_email: { backgroundColor: "#f8d7da", color: "#721c24" },
  outreach_fail_whatsapp: { backgroundColor: "#f8d7da", color: "#721c24" },
  outreach_fail_scout: { backgroundColor: "#f8d7da", color: "#721c24" },
  pipeline_not_interested: { backgroundColor: "#f8d7da", color: "#721c24" },
  delete_artist_email: { backgroundColor: "#f8d7da", color: "#721c24" },

  // Flagged outreach - orange/yellow
  outreach_flag_instagram_dm: { backgroundColor: "#fff3cd", color: "#856404" },
  outreach_flag_email: { backgroundColor: "#fff3cd", color: "#856404" },
  outreach_flag_whatsapp: { backgroundColor: "#fff3cd", color: "#856404" },
  outreach_flag_scout: { backgroundColor: "#fff3cd", color: "#856404" },

  // Updates / additions - purple
  update_artist_email: { backgroundColor: "#e2e3ff", color: "#3d3d8c" },
  add_artist_email: { backgroundColor: "#e2e3ff", color: "#3d3d8c" },
  set_default_artist_email: { backgroundColor: "#e2e3ff", color: "#3d3d8c" },
  instagram_update: { backgroundColor: "#e2e3ff", color: "#3d3d8c" },
  phone_update: { backgroundColor: "#e2e3ff", color: "#3d3d8c" },
  ig_data_fetch: { backgroundColor: "#e2e3ff", color: "#3d3d8c" },

  // Comments - gray
  artist_comment: { backgroundColor: "#e8e8e8", color: "#666" },
  task_comment: { backgroundColor: "#e8e8e8", color: "#666" },
  scout_comment: { backgroundColor: "#e8e8e8", color: "#666" },
  pipeline_artist_comment: { backgroundColor: "#e8e8e8", color: "#666" },

  // Meeting / contact - teal
  meeting_held: { backgroundColor: "#d1ecf1", color: "#0c5460" },
  contact_affiliate: { backgroundColor: "#d1ecf1", color: "#0c5460" },

  // Verification - green
  artist_verified: { backgroundColor: "#d4edda", color: "#155724" }
}

// Default badge style for unknown log types
export const DEFAULT_LOG_BADGE_STYLE: BadgeStyle = { backgroundColor: "#f0f0f0", color: "#333" }

// Helper function to get badge style for a log type
export const getLogTypeBadgeStyle = (type: string): BadgeStyle => {
  return USER_LOG_TYPE_BADGE_STYLES[type] || DEFAULT_LOG_BADGE_STYLE
}

// Artist Priority
export const ArtistPriorityChoices = {
  URGENT: 1,
  HIGH: 2,
  NORMAL: 3,
  LOW: 4
}

export const ArtistPriorityOptions: KSelectOption[] = [
  { value: ArtistPriorityChoices.URGENT, label: "Urgent" },
  { value: ArtistPriorityChoices.HIGH, label: "High" },
  { value: ArtistPriorityChoices.NORMAL, label: "Normal" },
  { value: ArtistPriorityChoices.LOW, label: "Low" }
]

interface PriorityBadgeStyle {
  label: string
  dotColor: string
  bgColor: string
  textColor: string
}

export const ARTIST_PRIORITY_BADGE_STYLES: { [key: number]: PriorityBadgeStyle } = {
  [ArtistPriorityChoices.URGENT]: {
    label: "Urgent",
    dotColor: "#EF4444",
    bgColor: "#FEE2E2",
    textColor: "#991B1B"
  },
  [ArtistPriorityChoices.HIGH]: {
    label: "High",
    dotColor: "#F59E0B",
    bgColor: "#FEF3C7",
    textColor: "#92400E"
  },
  [ArtistPriorityChoices.NORMAL]: {
    label: "Normal",
    dotColor: "#3B82F6",
    bgColor: "#DBEAFE",
    textColor: "#1E40AF"
  },
  [ArtistPriorityChoices.LOW]: {
    label: "Low",
    dotColor: "#6B7280",
    bgColor: "#F3F4F6",
    textColor: "#374151"
  }
}

export const DEFAULT_PRIORITY_BADGE_STYLE: PriorityBadgeStyle = {
  label: "No Priority",
  dotColor: "#9CA3AF",
  bgColor: "#F3F4F6",
  textColor: "#6B7280"
}

export const getPriorityBadgeStyle = (priority: number | null | undefined): PriorityBadgeStyle => {
  if (priority === null || priority === undefined) {
    return DEFAULT_PRIORITY_BADGE_STYLE
  }
  return ARTIST_PRIORITY_BADGE_STYLES[priority] || DEFAULT_PRIORITY_BADGE_STYLE
}

export const countryMapEn = {
  AF: "Afghanistan",
  AX: "Åland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Democratic Republic of the Congo",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Ivory Coast",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "North Korea",
  KR: "South Korea",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "North Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russia",
  RW: "Rwanda",
  BL: "Saint Barthélemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Dutch part)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}
